/**
 * Unified funnel tracking. Safe to call anywhere — every sink is a no-op if
 * that tracker isn't loaded, so it never breaks the page.
 *
 *   track('DemoStarted', { url_host }, 'Lead')
 *
 * - Pushes to dataLayer (GTM / GA4).
 * - Fires a Meta Pixel CUSTOM event (always) for granular funnel analysis.
 * - Fires a Meta Pixel STANDARD event too when the 3rd arg is given — those
 *   ('Lead', 'CompleteRegistration', 'InitiateCheckout', 'Purchase', …) are
 *   what Facebook ad sets optimise + report on.
 * - Tags Microsoft Clarity sessions so recordings can be segmented by step.
 */
declare global {
  interface Window {
    dataLayer?: any[];
    fbq?: (...args: any[]) => void;
    clarity?: (...args: any[]) => void;
  }
}

export function track(event: string, params: Record<string, any> = {}, metaStandardEvent?: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', event, params);
      if (metaStandardEvent) window.fbq('track', metaStandardEvent, params);
    }

    if (typeof window.clarity === 'function') window.clarity('event', event);
  } catch { /* tracking must never throw */ }
}
